import AboutFutarigift from '../views/sections/about-futarigift';
import AboutNavigation from '../views/sections/about-navigation';
import BestSellingProducts from '../views/sections/best-selling-products';
import BrandList from '../views/sections/brand-list';
import CollectionList from '../views/sections/collection-list';
import FeaturedBlog from '../views/sections/featured-blog';
import FeaturedCollection from '../views/sections/featured-collection';
import MainArticle from '../views/sections/main-article';
import MainIndexVisual from '../views/sections/main-index-visual';
import ProductBlocks from '../views/sections/product-blocks';
import ProductGiftWrapping from '../views/sections/product-gift-wrapping';
export default class{

    /**
     * constructor
     */
    constructor(){
        this.sections = {
            aboutFutarigift: new AboutFutarigift(),
            aboutNavigation: new AboutNavigation(),
            bestSellingProducts: new BestSellingProducts(),
            brandList: new BrandList(),
            collectionList: new CollectionList(),
            featuredBlog: new FeaturedBlog(),
            featuredCollection: new FeaturedCollection(),
            mainIndexVisual: new MainIndexVisual(),
            productBlocks: new ProductBlocks(),
            productGiftWrapping: new ProductGiftWrapping(),
            mainArticle: new MainArticle()
        };
    }

    /**
     * init
     */
    init(){
        for (const [key, value] of Object.entries(this.sections)) {
            value.init();
        };
    }

}
